import { styled } from '@mui/system';
import Button from '@mui/material/Button/index';
import { Divider, Paper, Typography } from '@mui/material';

export const SecurityCnt = styled('div')(() => ({
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto'
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing()
}));

export const StyledSubTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2)
  },
  display: 'flex',
  flexDirection: 'column'
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(2)
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledBtn = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
